import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var Loan =
/*#__PURE__*/
function (_BaseData) {
  _inherits(Loan, _BaseData);

  function Loan() {
    _classCallCheck(this, Loan);

    return _possibleConstructorReturn(this, _getPrototypeOf(Loan).call(this, "Loan"));
  }

  _createClass(Loan, [{
    key: "GetYears",
    value: function () {
      var _GetYears = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(ProjectId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(ProjectId == null)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetYears")));

              case 2:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetYears/").concat(ProjectId)));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetYears(_x) {
        return _GetYears.apply(this, arguments);
      }

      return GetYears;
    }()
  }, {
    key: "GetByProject",
    value: function () {
      var _GetByProject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(ProjectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByProject/").concat(ProjectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetByProject(_x2) {
        return _GetByProject.apply(this, arguments);
      }

      return GetByProject;
    }()
  }, {
    key: "GetLoanHistory",
    value: function () {
      var _GetLoanHistory = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(mitasNumber) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/LoanNumber/GetLoanHistory/".concat(mitasNumber)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetLoanHistory(_x3) {
        return _GetLoanHistory.apply(this, arguments);
      }

      return GetLoanHistory;
    }()
  }, {
    key: "GetByYear",
    value: function () {
      var _GetByYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(year) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(year == null)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByYear")));

              case 2:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByYear/").concat(year)));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetByYear(_x4) {
        return _GetByYear.apply(this, arguments);
      }

      return GetByYear;
    }()
  }, {
    key: "GetMcCardData",
    value: function () {
      var _GetMcCardData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(ProjectId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetMcCardData/").concat(ProjectId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetMcCardData(_x5) {
        return _GetMcCardData.apply(this, arguments);
      }

      return GetMcCardData;
    }()
  }, {
    key: "GetMitasNumbers",
    value: function () {
      var _GetMitasNumbers = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(uploadYear) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("/api/".concat(this._controller, "/GetMitasNumbers/").concat(uploadYear)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function GetMitasNumbers(_x6) {
        return _GetMitasNumbers.apply(this, arguments);
      }

      return GetMitasNumbers;
    }()
  }, {
    key: "GetProjectOptions",
    value: function () {
      var _GetProjectOptions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.get("/api/".concat(this._controller, "/GetProjectOptions")));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function GetProjectOptions() {
        return _GetProjectOptions.apply(this, arguments);
      }

      return GetProjectOptions;
    }()
  }, {
    key: "NotifyProperties",
    value: function () {
      var _NotifyProperties = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", axios.post("/api/".concat(this._controller, "/NotifyProperties")));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function NotifyProperties() {
        return _NotifyProperties.apply(this, arguments);
      }

      return NotifyProperties;
    }()
  }, {
    key: "GetProjectEquityData",
    value: function () {
      var _GetProjectEquityData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/".concat(this._controller, "/GetProjectEquityData")));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function GetProjectEquityData() {
        return _GetProjectEquityData.apply(this, arguments);
      }

      return GetProjectEquityData;
    }()
  }, {
    key: "HasActiveLoans",
    value: function () {
      var _HasActiveLoans = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(projectId, year) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", axios.get("/api/".concat(this._controller, "/HasActiveLoans/").concat(projectId, "/").concat(year)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function HasActiveLoans(_x7, _x8) {
        return _HasActiveLoans.apply(this, arguments);
      }

      return HasActiveLoans;
    }()
  }]);

  return Loan;
}(BaseData);

export default new Loan();